import { CdkDrag, CdkDragDrop, CdkDropList, CdkDropListGroup, moveItemInArray } from '@angular/cdk/drag-drop';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { Component, ContentChild, EventEmitter, Input, Output, TemplateRef } from '@angular/core';

export interface DragItem {
  disabled?: boolean;
}

@Component({
  selector: 'lc-drag-n-drop-cdk',
  templateUrl: './drag-n-drop-cdk.component.html',
  styleUrls: ['./drag-n-drop-cdk.component.scss'],
  imports: [CdkDropListGroup, CdkDropList, CdkDrag, NgClass, NgTemplateOutlet],
})
export class DragNDropCdkComponent {
  @Input() canDrag = true;
  @Input() canDrop = true;
  @Input() containerClass: string;
  @Input() containerId: string;
  @Input() itemClass: string;
  @Input() items: DragItem[] = [];
  @Input() additionalDrops: (CdkDropList | string)[] = [];
  @Input() verticalScrollbar = false;

  @Output() readonly reorder = new EventEmitter<DragItem[]>();

  @ContentChild(TemplateRef) itemTemplate: TemplateRef<unknown>;

  readonly canEnter = () => this.canDrop;

  onDrop(event: CdkDragDrop<DragItem[]>) {
    if (event.previousContainer !== event.container || event.previousIndex === event.currentIndex) return;

    moveItemInArray(this.items, event.previousIndex, event.currentIndex);
    this.reorder.emit([...this.items]);
  }
}
